'use client';

import {AlertBanner} from '@eds-web/react';
import {css} from '@panda/css';
import {EdsStatus} from '@common/hygraph-schema';
import {Text} from '@/components';
import {useSiteSettingsContext} from '@/context/SiteSettingsContext';
import {EdsIconElement, getEdsIcon} from '@/lib/utils/edsIcon.utils';

export function SiteBanner() {
	const {siteBannerEnabled, siteBannerMessage, siteBannerStatus, siteBannerIcon} =
		useSiteSettingsContext();

	if (!siteBannerEnabled || !siteBannerMessage) {
		return null;
	}

	const iconProp: {
		icon?: EdsIconElement;
	} = {};

	if (siteBannerStatus === EdsStatus.Neutral && siteBannerIcon) {
		iconProp.icon = getEdsIcon(siteBannerIcon);
	}

	return (
		<AlertBanner
			sticky
			status={siteBannerStatus || EdsStatus.Informational}
			message={<Text {...siteBannerMessage} />}
			{...iconProp}
			className={css({
				insetBlockStart: '72px !important',
				zIndex: 100,
				smDown: {
					justifyContent: 'left !important',
					'& > svg': {display: 'none'},
					paddingX: '1rem !important'
				}
			})}
		/>
	);
}
